var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.99609,
    r: 9,
    fill: "#01A585"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11708 8.80496L6.88779 6.57567C6.63645 6.32433 6.24305 6.32433 5.99171 6.57567L5.69666 6.87073C5.44532 7.12207 5.44532 7.51547 5.69666 7.76681L7.92594 9.99609L5.69666 12.2254C5.44532 12.4767 5.44532 12.8701 5.69666 13.1215L5.99171 13.4165C6.24305 13.6679 6.63645 13.6679 6.88779 13.4165L9.11708 11.1872L11.3464 13.4165C11.5977 13.6679 11.9911 13.6679 12.2424 13.4165L12.5375 13.1215C12.7888 12.8701 12.7888 12.4767 12.5375 12.2254L10.3082 9.99609L12.5375 7.76681C12.7888 7.51547 12.7888 7.12207 12.5375 6.87073L12.2424 6.57567C11.9911 6.32433 11.5977 6.32433 11.3464 6.57567L9.11708 8.80496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2351c999717699cdb52101bcaf7cdd7a.svg";
export { ForwardRef as ReactComponent };